import React from 'react'
import classNames from 'classnames'
import _ from 'lodash'
import {Rating} from './rating.component'
import {LunaConfirm} from '../lunaconfirm.component'

export class ItemTitleBlock extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            inItin: this.props.inItin ? this.props.inItin : false
        }

        _.bindAll(this,   
            'findInItin',
            'addToItin',
            'removeFromItin'
        )
    }	

    componentDidMount() {
        this.findInItin()
    }


    componentDidUpdate(prevProps, prevState) {
        console.log('itiem title updated?')
    // this.findInItin()
    }

    findInItin() {
        let myIndex = -1
        if (this.props.leg) {
            // do we have a valid leg?
            switch (this.props.type) {
                case 'destination':
                    // TODO: not sure if we need this
                    myIndex = this.props.inItin ? 1 : -1
                    break
                case 'accommodation':
                    myIndex = this.props.leg.get('accommodations').findIndex((accom) => {
                        return accom.get('id') === this.props.item.get('id')
                    })
                    break
                case 'attraction':
                    myIndex = this.props.leg.get('activities').findIndex((act) => {
                        return act.get('place_id') === this.props.item.get('place_id')
                    })
                    break
                case 'travel':
                    myIndex = this.props.transportation.findIndex((trans) => {
                        return trans.getIn(['transportation', 'transportation_guid']) === this.props.get('transportation_guid') 
                    })
                    break
            }
            if (myIndex >  -1) {
                if (!this.state.inItin) {
                    this.setState({inItin: true})
                }
            } else {
                if (!this.state.inItin) {
                    this.setState({inItin: false})
                }
            }
        }
    }

    addToItin() {
        this.setState({inItin: true})
        this.props.addToItin()
    }

    removeFromItin() {
        this.setState({inItin: false})
        this.props.removeFromItin()
    }

    render() {
        let btn = null

        if (this.props.type === 'destination') {
            btn = this.state.inItin ? <LunaConfirm type="ItemTitleBlockBlue" onConfirm={() => { this.removeFromItin() }} mssg="Are you sure you want to remove this destination and all associated items from your itinerary?"/>  :  <button className="btn btn-blue btn-flex" onClick={this.addToItin}><span>ADD</span><i className="icon-plus"/></button>
        } else {
            btn = this.state.inItin ? <LunaConfirm type="ItemTitleBlockRose" onConfirm={() => { this.removeFromItin() }} mssg="Are you sure you want to remove this item from your itinerary?"/> :  <button className="btn btn-rose btn-flex" onClick={this.addToItin}><span>Save</span><i className="icon-favorite"/></button>
        }
        let locState = this.props.item.getIn(['opencage', 'state']) ? <span><span className="divider">|</span>{ this.props.item.getIn(['opencage', 'state']) }</span> : ''
        // NOTE: Stripping all html out of the excerpt for styling purposes using jQuery        

        let starsCount = this.props.type === 'accommodation' ? this.props.item.getIn(['rating']) : this.props.item.getIn(['details', 0, 'rating'])
        let startPrice = this.props.type === 'accommodation' ? this.props.item.getIn(['price_range', 'low']) : this.props.item.getIn(['details', 0, 'price_range_min'])


        return (
            <div>
                <div className="item-title-block">
                    <div className="item-title-container">
                        <h1 className="item-title">{this.props.item.get('name')}{locState}</h1>
                        <h2 className="item-excerpt">{$('<div/>').html(this.props.item.get('excerpt') || this.props.item.get('overview')).text()}</h2>
                    </div>
                    <div className="item-title-actions">                                          
                        {btn}
                    </div>        
                </div>
                <div className="item-rating-block">
                    <Rating type="stars" itemLabel="rating" itemCount={starsCount}/>
                    <Rating type="startingPrice" itemCost={startPrice}/>
                </div>
            </div>
        )
    }
}
